// Mirror of server LEVEL_UNLOCKS — keep in sync with server/src/config.ts
// Full unlock table with types: Game, Zone, Feature

export const LEVEL_UNLOCKS = [
  { level: 1,  unlockId: 'game_blackjack',    type: 'Game',    displayName: 'game_blackjack' },
  { level: 1,  unlockId: 'game_roulette',     type: 'Game',    displayName: 'game_roulette' },
  { level: 2,  unlockId: 'game_dice',         type: 'Game',    displayName: 'unlock_dice',              path: '/dice' },
  { level: 3,  unlockId: 'game_hilo',         type: 'Game',    displayName: 'unlock_hilo',              path: '/hilo' },
  { level: 4,  unlockId: 'game_crash',        type: 'Game',    displayName: 'unlock_crash',             path: '/crash' },
  { level: 5,  unlockId: 'game_wheel',        type: 'Game',    displayName: 'unlock_wheel',             path: '/wheel' },
  { level: 6,  unlockId: 'game_limbo',        type: 'Game',    displayName: 'unlock_limbo',             path: '/limbo' },
  { level: 8,  unlockId: 'game_slots',        type: 'Game',    displayName: 'unlock_slots',             path: '/slot' },
  { level: 10, unlockId: 'game_keno',         type: 'Game',    displayName: 'unlock_keno',              path: '/keno' },
  { level: 12, unlockId: 'game_plinko',       type: 'Game',    displayName: 'unlock_plinko',            path: '/plinko' },
  { level: 15, unlockId: 'game_mines',        type: 'Game',    displayName: 'unlock_mines',             path: '/mines' },
  { level: 18, unlockId: 'game_tower',        type: 'Game',    displayName: 'unlock_tower',             path: '/tower' },
  { level: 20, unlockId: 'game_chicken',      type: 'Game',    displayName: 'unlock_chicken_cross',     path: '/chicken' },
];

// unlockId -> required level
export const UNLOCK_LEVEL_MAP = {};
for (const u of LEVEL_UNLOCKS) {
  UNLOCK_LEVEL_MAP[u.unlockId] = u.level;
}

// path -> unlockId (only for unlocks that have a route path)
export const PATH_TO_UNLOCK = {};
for (const u of LEVEL_UNLOCKS) {
  if (u.path) PATH_TO_UNLOCK[u.path] = u.unlockId;
}

// Tier color based on level
export function getTierColor(level) {
  if (level >= 100) return '#e04848'; // legendary red + particles
  if (level >= 50) return '#e04848';  // red
  if (level >= 40) return '#eab308';  // gold
  if (level >= 30) return '#a855f7';  // purple
  if (level >= 20) return '#c08515';  // gold
  if (level >= 10) return '#4caf50';  // green
  return '#9ca3af'; // gray
}

export function getTierName(level) {
  if (level >= 100) return 'Legendary';
  if (level >= 50) return 'Legend';
  if (level >= 40) return 'Gold';
  if (level >= 30) return 'Purple';
  if (level >= 20) return 'Blue';
  if (level >= 10) return 'Green';
  return 'Gray';
}
